// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnimatedRightPanel__container-daf14e {
  width: 360px;
  background-color: var(--addition-100);
  overflow: hidden;
  height: calc(100% - 16px);
  margin: 8px 8px 8px 0;
  border-radius: 8px;
}

.AnimatedRightPanel__container-requests-f5829d {
  position: absolute;
  right: 0;
  z-index: 3;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/AnimatedRightPanel/AnimatedRightPanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,qCAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AACF","sourcesContent":[".container {\n  width: 360px;\n  background-color: var(--addition-100);\n  overflow: hidden;\n  height: calc(100% - 16px);\n  margin: 8px 8px 8px 0;\n  border-radius: 8px;\n}\n\n.container-requests {\n  position: absolute;\n  right: 0;\n  z-index: 3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AnimatedRightPanel__container-daf14e`,
	"container-requests": `AnimatedRightPanel__container-requests-f5829d`,
	"containerRequests": `AnimatedRightPanel__container-requests-f5829d`
};
module.exports = ___CSS_LOADER_EXPORT___;
